import { render, staticRenderFns } from "./statsByTruck.vue?vue&type=template&id=12f5e80b&"
import script from "./statsByTruck.vue?vue&type=script&lang=js&"
export * from "./statsByTruck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports